"use strict";
var angular = require("angular");

var ctrl = [
  "Form",
  function (Form) {
    var _this = this;
    _this.value = 0;    
    _this.color= "white"
    try {
      if (this.validateRequired)
        Form.itemsPendingCount({
          formId: this.formId,
          deptId: this.deptId,
        }).$promise.then(function (resp) {          
          _this.value = resp.response.count;
          _this.color= "steelblue"
          if(resp.response.lastPending && resp.response.lastPending._createdAt && ((new Date().getTime() - new Date(resp.response.lastPending._createdAt).getTime() ) / (1000*60*60*24)) >10)
            _this.color="red"
        });
    } catch (e) {}
  },
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      formId: "=",
      deptId: "=",
      validateRequired: "=",
      validateInstances: "=",
    },
    controller: ctrl,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl: "directives/pendingValidateBadge.html",
  };
};
